// src/components/UppyUpload.jsx
import { flushSync } from 'react-dom';
import React, { useEffect, useRef, useState } from "react";
import Uppy from "@uppy/core";
import { Dashboard } from "@uppy/react";
import XHRUpload from "@uppy/xhr-upload";
import de_DE from "@uppy/locales/lib/de_DE";
import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import "./UppyUpload.css";

const ACCEPTED_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/png",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];
const MAX_FILE_SIZE_MB = 5;
const MAX_FILE_COUNT = 5;






export default function UppyUpload() {
  const [accessGranted, setAccessGranted] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [uploadCanceled, setUploadCanceled] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [showRequestAccess, setShowRequestAccess] = useState(false);

  const DEFAULT_BRANDING = {
    homepage: "https://stellenfabrik.de",
    logoUrl: null,
    logoMaxWidth: "200px",
    stripeColor: "#fff",
    avatarUrl: null,
    widgetText: null,
    impressum: "https://stellenfabrik.de/impressum",
    datenschutz: "https://stellenfabrik.de/datenschutz",
    };


const [reloadFlag, setReloadFlag] = useState(false);

const uppy = useRef(
  (() =>
    new Uppy({
      id: "MyUppyInstance", // optional, aber empfohlen
      restrictions: {
        maxFileSize: MAX_FILE_SIZE_MB * 1024 * 1024,
        maxNumberOfFiles: MAX_FILE_COUNT,
        allowedFileTypes: ACCEPTED_TYPES,
      },
      autoProceed: false,
    })
)() 
).current;

    // ... dein bestehender State ...
    const [branding, setBranding] = useState(null); // ← NEU

    // Kleine URL-Hilfsfunktion (String | {url} | [{url}])
    const pickUrl = (val) => {
        if (!val) return null;
        if (typeof val === "string") return val;
        if (Array.isArray(val)) return val[0]?.url || null;
        if (typeof val === "object" && val.url) return val.url;
        return null;
    };


useEffect(() => {
  console.log("⚪ mounted");
  return () => {
    console.log("🔴 unmounted → uppy.close()");
    uppy.close();
  };
}, []);




// Klick-Listener
useEffect(() => {
  const onClick = (e) => {
    if (e.target.closest('.uppy-DashboardContent-back')) {
      console.log('[Uppy] Cancel erkannt → reset + reloadFlag=true');
      flushSync(() => setReloadFlag(true));
    }
  };
  document.addEventListener('click', onClick, true);
  return () => document.removeEventListener('click', onClick, true);
}, []);





useEffect(() => {
  const hash = window.location.hash.split("?")[1] || "";
  const params = new URLSearchParams(hash);
  const rid = params.get("record_id");
  const cid = params.get("customer_id") || null;
  const recordIdRegex = /^rec[a-zA-Z0-9]{14,}$/;
  const token = params.get("upload_token");
  const uid = params.get("user_id");
  const loc = params.get("loc") || "";
  const rawLoc = (params.get("loc") || "").toLowerCase();
  const isLink = rawLoc === "link";

  if (isLink) {
  setBranding(prev => prev ?? DEFAULT_BRANDING);
} else {
  setBranding(null); // Branding strikt aus
}

console.log("🔍 Geparst aus URL:", { rid, cid, token });

  if (!rid || !recordIdRegex.test(rid)) {
    setError("❌ Ungültige oder fehlende record_id.");
    return;
  }

  // 🛡️ Zugriff prüfen, BEVOR Upload eingerichtet wird
// 🛡️ Zugriff prüfen, BEVOR Upload eingerichtet wird
const checkAccess = async () => {
  // Wir halten die Request-URL hier, damit sie im catch sichtbar ist
  let reqUrl = "";
  try {
    const url = new URL("/api/verify-upload-token", "https://upload.sellermind.de");
    url.searchParams.set("record_id", rid);
    url.searchParams.set("customer_id", cid || "");
    url.searchParams.set("token", token || "");
    url.searchParams.set("user_id", uid || "");
    url.searchParams.set("loc", loc || "");

    reqUrl = url.toString();

    console.log("------------  reUrl", reqUrl);

    if (!token) {
      setError("❌ Kein Upload-Token in der URL gefunden.");
      return;
    }

    const res = await fetch(reqUrl, { method: "GET" });
    const data = await res.json().catch(() => ({}));
     console.log("res", res);

    if (!res.ok) {


  if (isLink) {
    setBranding(prev => ({
      ...(prev || DEFAULT_BRANDING),
      homepage: data?.Alternative_Karriereseite ?? prev?.homepage ?? DEFAULT_BRANDING.homepage,
      logoUrl: (pickUrl(data?.Logo) ?? prev?.logoUrl ?? null),
      logoMaxWidth: (data?.Logo_Max_Width || prev?.logoMaxWidth || "200px"),
      stripeColor: (data?.Color_Streifen_Hex || prev?.stripeColor || "#0a0a0a"),
      avatarUrl: (pickUrl(data?.Avatar) ?? prev?.avatarUrl ?? null),
      widgetText: (data?.WidgetText ?? prev?.widgetText ?? null),
      impressum: (data?.Impressum || prev?.impressum || DEFAULT_BRANDING.impressum),
      datenschutz: (data?.Datenschutz || prev?.datenschutz || DEFAULT_BRANDING.datenschutz),
    }));
  }


        if (res.status === 403 || res.status === 410) {
            setShowRequestAccess(true);
            setLoading(false);
            return;
        }

      const text = await res.text().catch(() => "");
      throw new Error(`HTTP ${res.status}${text ? " – " + text : ""}`);
    }

    //const data = await res.json().catch(() => ({}));
    if (data.valid !== true) {
      throw new Error("Antwort erhalten, aber kein gültiger Upload-Token.");
    }


// Hier neu hinzugekommen
   if(isLink) setBranding(prev => ({
   ...(prev || DEFAULT_BRANDING),
   homepage: data?.Alternative_Karriereseite ?? prev?.homepage ?? DEFAULT_BRANDING.homepage,
   logoUrl: (pickUrl(data?.Logo) ?? prev?.logoUrl ?? null),
   logoMaxWidth: (data?.Logo_Max_Width || prev?.logoMaxWidth || "200px"),
   stripeColor: (data?.Color_Streifen_Hex || prev?.stripeColor || "#0a0a0a"),
   avatarUrl: (pickUrl(data?.Avatar) ?? prev?.avatarUrl ?? null),
   widgetText: (data?.WidgetText ?? prev?.widgetText ?? null),
   impressum: (data?.Impressum || prev?.impressum || DEFAULT_BRANDING.impressum),
   datenschutz: (data?.Datenschutz || prev?.datenschutz || DEFAULT_BRANDING.datenschutz),
 }));

// bis hier

    const exists = data.existing;
    const list = Array.isArray(data?.files) ? data.files : [];




 if(exists) {
  try {

    // 1) Kacheln hinzufügen – JEDE mit attachmentId
    // for (const f of list) {
    //   await uppy.addFile({
    //     name: `🟩 Vorhanden · ${f.filename || "existing-file"}`,
    //     type:
    //       (f.filename?.toLowerCase().endsWith(".pdf"))  ? "application/pdf" :
    //       (f.filename?.toLowerCase().endsWith(".jpg") || f.filename?.toLowerCase().endsWith(".jpeg")) ? "image/jpeg" :
    //       (f.filename?.toLowerCase().endsWith(".png"))  ? "image/png" :
    //       (f.filename?.toLowerCase().endsWith(".doc"))  ? "application/msword" :
    //       (f.filename?.toLowerCase().endsWith(".docx")) ? "application/vnd.openxmlformats-officedocument.wordprocessingml.document" :
    //       "application/octet-stream",
    //     data: new Blob([new Uint8Array(0)], {
    //       type:
    //         (f.filename?.toLowerCase().endsWith(".pdf"))  ? "application/pdf" :
    //         (f.filename?.toLowerCase().endsWith(".jpg") || f.filename?.toLowerCase().endsWith(".jpeg")) ? "image/jpeg" :
    //         (f.filename?.toLowerCase().endsWith(".png"))  ? "image/png" :
    //         (f.filename?.toLowerCase().endsWith(".doc"))  ? "application/msword" :
    //         (f.filename?.toLowerCase().endsWith(".docx")) ? "application/vnd.openxmlformats-officedocument.wordprocessingml.document" :
    //         "application/octet-stream"
    //     }),
    //     meta: {
    //       existing: true,
    //       attachmentId: f.id,
    //       originalSize: f.size || 0,
    //       originalUrl: f.url || "",
    //     },
    //   });

    //   // ⬅️ HIER hinzufügen
    //   const last = uppy.getFiles().slice(-1)[0];
    //   if (last) {
    //     uppy.setFileMeta(last.id, {
    //       existing: true,
    //       attachmentId: f.id
    //     });
    //     uppy.setFileState(last.id, { preview: f.url || "" });
    //   }
    // }




// ab hier neuer Code

const determineMimeType = (filename = "") => {
  const f = filename.toLowerCase();
  if (f.endsWith(".pdf")) return "application/pdf";
  if (f.endsWith(".jpg") || f.endsWith(".jpeg")) return "image/jpeg";
  if (f.endsWith(".png")) return "image/png";
  if (f.endsWith(".doc")) return "application/msword";
  if (f.endsWith(".docx")) return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  return "application/octet-stream";
};


// ✅ Zeige sofort das UI
setAccessGranted(true);
setLoading(false);

// ✅ Dateien asynchron einfügen – blockiert NICHT das UI
setTimeout(() => {
  if (!data.existing || !Array.isArray(data.files)) return;

  const list = data.files;
  for (const f of list) {
    try {
      uppy.addFile({
        name: `🟩 Vorhanden · ${f.filename || "existing-file"}`,
        type: determineMimeType(f.filename),
        data: new Blob([new Uint8Array(0)], {
          type: determineMimeType(f.filename),
        }),
        meta: {
          existing: true,
          attachmentId: f.id,
          originalSize: f.size || 0,
          originalUrl: f.url || "",
        },
      });

      const last = uppy.getFiles().slice(-1)[0];
      if (last) {
        uppy.setFileMeta(last.id, {
          existing: true,
          attachmentId: f.id,
        });
        uppy.setFileState(last.id, { preview: f.url || "" });
      }

    } catch (e) {
      console.warn("Fehler beim Hinzufügen einer Datei:", e);
    }
  }

  // ⬅️ Pflicht: IDs nachziehen
  syncKeepIds();
}, 100); // 100ms nach UI-Anzeige starten


// Bis hier neuer Code dann geht es wie vorher weiter

      // 2) Alle bestehenden auf 100 % Fortschritt setzen
      const filesNow = uppy.getFiles();
      for (const file of filesNow) {
        if (file?.meta?.existing === true) {
          const bytes = file?.meta?.originalSize || file.size || 0;
          uppy.setFileState(file.id, {
            progress: {
              uploadStarted: true,
              uploadComplete: true,
              percentage: 100,
              bytesUploaded: bytes,
              bytesTotal: bytes,
            },
          });
        }
      }



// ✅ Meta-Felder bei allen bestehenden Dateien sicherstellen
uppy.getFiles().forEach(file => {
  console.log("File VOR SCHON GESETZT", file)
  if (file?.meta?.existing === true && file?.meta?.attachmentId) return; // schon gesetzt

  const idToUse = file.meta?.attachmentId || file.id;
  console.log("🔍 Setze Meta für bestehende Datei:", {
    fileId: file.id,
    existing: true,
    attachmentId: idToUse
  });

  uppy.setFileMeta(file.id, {
    existing: true,
    attachmentId: idToUse
  });
});




      // 3) Sicherstellen: bestehende Kacheln werden NICHT hochgeladen
//      if (!uppy.__filterExistingOnce) {
//        uppy.on("before-upload", (files) => {
//          return files;
//        });
//        uppy.__filterExistingOnce = true;
//      }

      // 4) (Hilfsfunktion für späteres Speichern)
      //    Liefert alle IDs der aktuell sichtbaren, bestehenden Dateien.
      uppy.getKeepIds = () => {
        return uppy
          .getFiles()
          .filter(f => f?.meta?.existing === true && f?.meta?.attachmentId)
          .map(f => f.meta.attachmentId);
      };
      // Beispiel-Check:
      console.log("KEEP_IDS jetzt:", uppy.getKeepIds());

  } catch (e) {
    console.warn("GET /api/files error:", e?.message || e);
  }

uppy.on('file-added', (file) => {
  if (file.meta.existing === undefined) {
    uppy.setFileMeta(file.id, { existing: false });
  }
});



}


/// BIS HIER


// ⬅️ HIER EINBAUEN – z. B. direkt vor dem Upload-Start
// ✅ Zugriff erlaubt → Upload vorbereiten

uppy.setMeta({
  record_id: rid,
  customer_id: cid,
  token: token,
  user_id: uid,
  loc: loc,
});

// ⬅️ HIER EINBAUEN – Root-Meta für bestehende Dateien setzen



// immer einen Default setzen – niemals undefined im Request
// Default nur setzen, wenn noch NICHT vorhanden
const meta = uppy.getState().meta || {};
if (typeof meta.keep_ids === "undefined") {
  uppy.setMeta({ keep_ids: "[]" });
}



// Helper, der keep_ids aus den Files berechnet und als STRING setzt
const syncKeepIds = () => {
  const ids = uppy
    .getFiles()
    .filter(f => f?.meta?.existing === true && typeof f?.meta?.attachmentId === "string" && f.meta.attachmentId.length > 0)
    .map(f => f.meta.attachmentId);

  uppy.setMeta({ keep_ids: JSON.stringify(ids) });
  console.log("[Uppy] keep_ids set ->", uppy.getState().meta.keep_ids);
};

// sofort einmal berechnen …
syncKeepIds();

// … bei Änderungen nachziehen
uppy.on("file-added", (file) => {
  console.log("[Uppy] file-added:", { id: file.id, name: file.name, existing: file.meta?.existing, attachmentId: file.meta?.attachmentId });
  syncKeepIds();
});
uppy.on("file-removed", (file) => {
  console.log("[Uppy] file-removed:", { id: file?.id, name: file?.name });
  syncKeepIds();
});
uppy.on("upload", () => {
  console.log("[Uppy] upload event (pre): meta =", uppy.getState().meta);
  syncKeepIds();
  console.log("[Uppy] upload event (post): meta =", uppy.getState().meta);
});

// 🔑 WICHTIG: ganz kurz vor dem Bauen der FormData – letzter Sicherungs-Call
uppy.on("before-upload", (files) => {
  console.log("[Uppy] before-upload: files=", Object.values(files).map(f => ({
    id: f.id, name: f.name, existing: f.meta?.existing, attachmentId: f.meta?.attachmentId
  })));
  console.log("[Uppy] before-upload (pre): meta =", uppy.getState().meta);
  syncKeepIds();
  console.log("[Uppy] before-upload (post): meta =", uppy.getState().meta);
});




//uppy.use(XHRUpload, {
//  endpoint: "https://upload.sellermind.de/api/upload",
//  fieldName: "files",
//  formData: true,
//  bundle: true,
//allowedMetaFields: [
//  "record_id",
//  "customer_id",
//  "token",
//  "user_id",
//  "keep_ids"        // ⬅️ NEU: das eine Root-Feld, das wir senden
//],
//});


// ⬇️ ERSETZE deinen gesamten uppy.use(XHRUpload, {...}) Block durch:
const plugin = uppy.getPlugin('XHRUpload');
if (plugin) {
  // Plugin existiert schon → NUR Optionen aktualisieren
  plugin.setOptions({
    endpoint: "https://upload.sellermind.de/api/upload",
    fieldName: "files",
    formData: true,
    bundle: true,
    allowedMetaFields: [
      "record_id",
      "customer_id",
      "token",
      "user_id",
      "keep_ids",
    ],
  });
  console.log("[Uppy] XHRUpload Optionen aktualisiert");
} else {
  // Plugin noch nicht registriert → einmalig registrieren
  uppy.use(XHRUpload, {
    endpoint: "https://upload.sellermind.de/api/upload",
    fieldName: "files",
    formData: true,
    bundle: true,
    allowedMetaFields: [
      "record_id",
      "customer_id",
      "token",
      "user_id",
      "keep_ids",
    ],
  });
  console.log("[Uppy] XHRUpload registriert");
}




uppy.on("complete", (result) => {
  if (result.successful.length === 0 && result.failed.length === 0) {
    // 👤 Upload manuell abgebrochen → KEINE Fehlermeldung, aber Hinweis anzeigen
    setUploadCanceled(true);
    return;
  }

  if (result.failed.length > 0) {
    const firstError = result.failed[0]?.error;
    const isCanceled = firstError?.message?.toLowerCase().includes("canceled");

    if (isCanceled) {
      // 👤 Upload manuell abgebrochen (zweiter möglicher Fall)
      setUploadCanceled(true);
      return;
    }

    // ❌ Echter Fehler
    const reason = firstError?.message || "Unbekannter Fehler beim Upload.";
    setError("❌ Upload fehlgeschlagen: " + reason);
    return;
  }

  // ✅ Erfolgreich
  setUploadSuccess(true);
  window.parent?.postMessage({ type: "upload-success", recordId: rid }, "*");
});



setAccessGranted(true);
setLoading(false);


} catch (err) {
  console.log("ERROR", err);

  setAccessGranted(false);
  setLoading(false);

}
};

  checkAccess();

if (reloadFlag) setReloadFlag(false);

//  return () => uppy.close();
}, [reloadFlag]);






useEffect(() => {
  const handleFileAdded = () => {
    setUploadCanceled(false);
  };

  const handleUploadStart = () => {
    setUploadCanceled(false);
  };

  uppy.on("file-added", handleFileAdded);
  uppy.on("upload", handleUploadStart);

  return () => {
    uppy.off("file-added", handleFileAdded);
    uppy.off("upload", handleUploadStart);
  };
}, [uppy]);



useEffect(() => {
  if (!loading) return;
  const t = setTimeout(() => {
    // falls Verify zu lange dauert -> Formular zeigen
    setShowRequestAccess(true);
    setLoading(false);
  }, 8000);
  return () => clearTimeout(t);
}, [loading]);


// Wrappt Body mit Template-Header/Main/Footer – oder gibt Body pur zurück
// !!! NICHTS am Design ändern – 1:1 dein Block, nur {body} statt {coreBody}
const renderWithBranding = (body) => {
  if (!branding) return body;

  return (
    <>
      {/* HEADER */}
      <div className="logodiv">
        <div id="logodiv" className="logo-container">
          <a href={branding.homepage}>
            {branding.logoUrl && (
              <img id="logo" src={branding.logoUrl} alt="Kundenlogo" style={{ maxWidth: branding.logoMaxWidth }} />
            )}
          </a>
        </div>
      </div>

      <div id="color_streifen" className="header" style={{ backgroundColor: branding.stripeColor }}>
        <div className="header-container">
          <div className="avatar" style={{ display: branding.avatarUrl ? "block" : "none" }}>
            {branding.avatarUrl && <img id="img_avatar" className="img_avatar" src={branding.avatarUrl} alt="Avatar" />}
          </div>
          <div className="head" style={{ display: branding.widgetText ? "block" : "none" }}>
            {branding.widgetText}
          </div>
        </div>
      </div>

      {/* MAIN – unverändert */}
      {body}

      {/* FOOTER */}
      <div className="footer">
        <div className="input-container" style={{ display: "none" }}>
          <input type="text" placeholder="Jetzt Cookies bestätigen &amp; Traumjob finden..." />
        </div>
        <div className="cookie-button-container" style={{ paddingBottom: "0rem", display: "none" }}>
          <button className="cookie-button" onClick={() => {}}>
            Jetzt KI-Chat starten &amp;  Traumjob sichern
          </button>
        </div>
        <div className="rechtliches">
          <a href={branding.impressum}>Impressum</a> | <a href={branding.datenschutz}>Datenschutz</a>
        </div>
      </div>
    </>
  );
};


if (showRequestAccess || (!accessGranted && !loading)) {
  return renderWithBranding(<RequestAccessForm />);
}




if (loading && !showRequestAccess) {
  return renderWithBranding(
    <div className="u-container">
      <div className="u-card u-loading-card">
        <div className="spinner" />
        <p className="u-text">Lade Upload-Bereich…</p>
      </div>
    </div>
  );
}



if (error) {
  return renderWithBranding(
    <div className="u-container">
      <div className="u-card u-error-card">
        <h2 className="u-heading">Fehler</h2>
        <p className="u-text">{String(error)}</p>
      </div>
    </div>
  );
}

//if (uploadSuccess) return <div className="u-success">✅ Deine Unterlagen wurden erfolgreich hochgeladen.</div>;

if (uploadSuccess) {
  return renderWithBranding(
    <div className="u-container">
      <div className="u-card u-success-card">
        <h2 className="u-heading">✅ Upload erfolgreich</h2>
        <p className="u-text">
          Vielen Dank! Deine Bewerbungsunterlagen wurden sicher übermittelt.<br />
          Du erhältst in Kürze eine Rückmeldung von uns.
        </p>
      </div>
    </div>
  );
}


if (!accessGranted) return null;


  // ***** Dein bisheriger Upload-Body unverändert *****
  const coreBody = (
    <div className="u-container">
      <div className="u-card">
        <h2 className="u-heading">Bewerbungsunterlagen hochladen</h2>
        <p className="u-text">Wähle deine Unterlagen aus oder ziehe sie in den grauen Bereich.</p>

        <Dashboard
          uppy={uppy}
          inline
          height={340}
          proudlyDisplayPoweredByUppy={false}
          openFileDialogOnClick
          note="Max. 5 Dateien • PDF, JPG, PNG, DOC, DOCX • max. 5 MB"
          showProgressDetails
          showRemoveButtonAfterComplete={true}
          disableInformer={true}
          locale={de_DE}
        />

        {uploadCanceled && (
          <div className="u-hint u-info">
            ⏹️ Der Upload wurde abgebrochen. Du kannst es jederzeit erneut versuchen.
          </div>
        )}
      </div>
    </div>
  );

  return renderWithBranding(coreBody);

}



function RequestAccessForm() {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);

  const hash = window.location.hash.split("?")[1] || "";
  const params = new URLSearchParams(hash);
  const rid = params.get("record_id") || "";
  const cid = params.get("customer_id") || "";
  const uid = params.get("user_id") || "";

    const onSubmit = async (e) => {
    e.preventDefault();
    setErr(null); setMsg(null);

    const mail = (email || "").trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
        setErr("Bitte gib eine gültige E-Mail ein.");
        return;
    }

    setSending(true);
    try {
        // alle Hash-Parameter (record_id, customer_id, user_id, loc, upload_token, …) übernehmen
        const hash = window.location.hash.split("?")[1] || "";
        const srcParams = new URLSearchParams(hash);

        // klonen + email ergänzen
        const qs = new URLSearchParams(srcParams);
        qs.set("email", mail);

        const url = `https://upload.sellermind.de/api/send-access?${qs.toString()}`;
        const res = await fetch(url, { method: "POST" }); // ✨ keine Header

        const data = await res.json().catch(() => ({}));
        if (res.ok && data?.ok) {
        if (data.access_link) {
            window.location.href = data.access_link; // direkt weiter
            return;
        }
        setMsg("✅ Prüfe deine E-Mail. Wir haben dir einen neuen Zugang geschickt.");
        } else {
        setErr(
            data?.reason === "email_not_found"
            ? "E-Mail wurde nicht gefunden. Bitte prüfe die Eingabe."
            : "Konnte keinen neuen Zugriff erstellen."
        );
        }
    } catch {
        setErr("Netzwerkfehler. Bitte später erneut versuchen.");
    } finally {
        setSending(false);
    }
    };


return (
  <div className="u-container u-access-form">
    <div className="u-card access-card">
      <h2 className="access-title">Zugriff auf das Bewerberportal erneuern</h2>
      <p className="access-sub">Gib deine E-Mail ein, um einen neuen Zugriff zu erhalten.</p>

      <form className="access-form" onSubmit={onSubmit} noValidate>
        <label htmlFor="access-email" className="sr-only">E-Mail-Adresse</label>
        <input
          id="access-email"
          className="access-input"
          type="email"
          inputMode="email"
          autoComplete="email"
          required
          placeholder="dein.name@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          aria-describedby={(err || msg) ? "access-feedback" : undefined}
        />

        <button className={`access-btn ${sending ? "is-loading" : ""}`} type="submit" disabled={sending}>
          {sending ? "Wird geprüft…" : "Neuen Zugriff gewähren"}
        </button>
      </form>

      {(err || msg) && (
        <p id="access-feedback"
           className={`access-msg ${err ? "access-msg--error" : "access-msg--ok"}`}
           role={err ? "alert" : "status"}
           aria-live="polite">
          {err || msg}
        </p>
      )}
    </div>
  </div>
);
}
